// Báo cho người dùng biết hóa đơn điều chỉnh/thay thế này được tạo từ bảng kê,
// mở từ icon dấu chấm than ở danh sách HĐ điều chỉnh / thay thế.
import PropTypes from "prop-types";
import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const FromStatementModal = props => {
  const { isOpen, toggle, statementId } = props;

  return (
    <Modal isOpen={isOpen} role="dialog" autoFocus centered toggle={toggle}>
      <div className="modal-content">
        <ModalHeader toggle={toggle}>Nguồn tạo hóa đơn</ModalHeader>
        <ModalBody>
          <div className="alert alert-info mb-0 d-flex align-items-center gap-2">
            <i className="bx bx-info-circle font-size-18" />
            <span>
              HĐ tạo từ bảng kê thay thể/điều chỉnh
              {statementId ? ` (ID bảng kê: ${statementId})` : ""}
            </span>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" outline onClick={toggle}>
            Đóng
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

FromStatementModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  statementId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

FromStatementModal.defaultProps = {
  isOpen: false,
  statementId: null,
};

export default FromStatementModal;
